// extracted by mini-css-extract-plugin
export default {"icon":"sRIzV9"};